import { type BadgeProps } from '@wartek-id/badge'

import type { PerencanaanFilterState } from 'types/kinerja-tim-penilai-ps'
import type { StatusPerencanaan } from 'types/kinerja-ps-pegawai'

const BADGE_STATES: {
  [key in StatusPerencanaan]: {
    color: BadgeProps['variant']
    badgeClassName: string
    text: string
  }
} = {
  MULAI_PERENCANAAN: {
    color: 'neutral',
    badgeClassName: '!bg-surface-neutral-subdued !border-none',
    text: 'Belum diajukan',
  },
  SIAP_DIAJUKAN: {
    color: 'neutral',
    badgeClassName: '!bg-surface-neutral-subdued !border-none',
    text: 'Belum diajukan',
  },
  SEDANG_DIPERIKSA: {
    color: 'informational',
    badgeClassName: 'bg-surface-informational-subdued',
    text: 'Menunggu pemeriksaan',
  },
  DIKIRIM_TK: {
    color: 'informational',
    badgeClassName: 'bg-surface-informational-subdued',
    text: 'Sudah diperiksa Tim Kinerja dan perlu disetujui Pejabat Penilai Kinerja',
  },
  DIARAHKAN_REVISI_TK: {
    color: 'warning',
    badgeClassName: 'bg-surface-warning-subdued',
    text: 'Revisi dari Tim Kinerja',
  },
  DIARAHKAN_REVISI_PPK: {
    color: 'warning',
    badgeClassName: 'bg-surface-warning-subdued',
    text: 'Revisi dari Pejabat Penilai Kinerja',
  },
  SUDAH_DIREVISI: {
    color: 'informational',
    badgeClassName: 'bg-surface-informational-subdued',
    text: 'Sudah direvisi',
  },
  DISETUJUI_PPK: {
    color: 'success',
    badgeClassName: 'bg-surface-success-subdued',
    text: 'Disetujui Pejabat Penilai Kinerja',
  },
  PELAKSANAAN_DIMULAI: {
    color: 'success',
    badgeClassName: 'bg-surface-success-subdued',
    text: 'Disetujui Pejabat Penilai Kinerja',
  },
}

export function getApprovalStateProps(state: StatusPerencanaan): {
  color: BadgeProps['variant']
  badgeClassName: string
  text: string
} {
  return (
    BADGE_STATES[state] || {
      color: 'neutral',
      badgeClassName: 'bg-surface-neutral-subdued',
      text: state,
    }
  )
}

export const FILTER_STATE: {
  [key in PerencanaanFilterState]: string
} = {
  ALL: 'Semua Status',
  BELUM_DIAJUKAN_PENGAWAS: 'Belum diajukan',
  SUDAH_DIAJUKAN_PENGAWAS: 'Menunggu pemeriksaan',
  BELUM_DISETUJUI_PEJABAT_PENILAI_KINERJA:
    'Sudah diperiksa Tim Kinerja dan perlu disetujui Pejabat Penilai Kinerja',
  DIARAHKAN_REVISI_OLEH_TIM_KERJA: 'Revisi dari Tim Kinerja',
  DIARAHKAN_REVISI_OLEH_PEJABAT_PENILAI_KINERJA:
    'Revisi dari Pejabat Penilai Kinerja',
  SUDAH_DIREVISI_PENGAWAS: 'Sudah direvisi',
  DISETUJUI_PEJABAT_PENILAI_KINERJA: 'Disetujui Pejabat Penilai Kinerja',
  DAPAT_DISETUJUI_SEKALIGUS: 'Dapat disetujui sekaligus',
}

export function getFilterText(state: PerencanaanFilterState) {
  return FILTER_STATE[state] ?? state
}
